module.exports = "/_next/static/images/loading_19-bff24dd1a1e01222d1d234aefbbd7129.png";